import { render, staticRenderFns } from "./StoreSorter.vue?vue&type=template&id=2eb41306&scoped=true&"
import script from "./StoreSorter.vue?vue&type=script&lang=js&"
export * from "./StoreSorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb41306",
  null
  
)

export default component.exports